import React from 'react';

const CompleteIcon = ({style}) => {
  return (
    <svg style={style} width='108' height='108' viewBox='0 0 108 108' xmlns='http://www.w3.org/2000/svg'>
        <g id='iOS' fill='none' fillRule='evenodd'>
          <g id='popup_saved' transform='translate(-321 -584)' stroke='#64C2E6' strokeWidth='4'>
            <g id='Group-9'>
              <g id='Popup' transform='translate(255 547)'>
                <g id='icon' transform='translate(24 24)'>
                  <g id='Confirm' transform='translate(42 13)'>
                    <path
                      d='M54,106 C82.718807,106 106,82.718807 106,54 C106,46.4088571 104.37358,39.0514333 101.273472,32.3071452 C92.8534232,13.9893183 74.5161949,2 54,2 C25.281193,2 2,25.281193 2,54 C2,82.718807 25.281193,106 54,106 Z'
                      id='Oval'
                    />
                    <polyline
                      id='Path-2'
                      strokeLinecap='round'
                      points='27.5 54.75 45.5 73.5 82.5 37.5'
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
  );
};

export default CompleteIcon;


// WEBPACK FOOTER //
// ./src/app/nest/components/CompleteIcon/CompleteIcon.js